// External re-export isolated into a source file so the package barrel stays generator-managed.
export { default as pluralize } from 'pluralize';
